import { fetchWithAuth } from './api';

// Generate or retrieve session ID
export const getVisitSessionId = () => {
  let sessionId = sessionStorage.getItem('visit_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('visit_session_id', sessionId);
  }
  return sessionId;
};

// Track a page visit
export const trackVisit = async (pageType, pageId = null) => {
  try {
    const sessionId = getVisitSessionId();
    const referrer = document.referrer || null;

    await fetchWithAuth('/visits/log', {
      method: 'POST',
      body: {
        pageType,
        pageId,
        sessionId,
        referrer
      }
    });
  } catch (error) {
    // Silently fail - we don't want tracking to break the user experience
    console.debug('Visit tracking failed:', error);
  }
};

// Admin: Get analytics
export const getVisitAnalytics = async () => {
  return fetchWithAuth('/visits/analytics', {
    method: 'GET'
  });
};

// Admin: Get paginated visits with filters
export const getVisits = async (filters = {}, page = 0, size = 50) => {
  const params = new URLSearchParams();
  
  if (filters.pageType) params.append('pageType', filters.pageType);
  if (filters.pageId) params.append('pageId', filters.pageId);
  if (filters.trafficType) params.append('trafficType', filters.trafficType);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  params.append('page', page);
  params.append('size', size);

  return fetchWithAuth(`/visits?${params.toString()}`, {
    method: 'GET'
  });
};

// Admin: Export all visits with filters
export const exportVisits = async (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.pageType) params.append('pageType', filters.pageType);
  if (filters.pageId) params.append('pageId', filters.pageId);
  if (filters.trafficType) params.append('trafficType', filters.trafficType);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);

  return fetchWithAuth(`/visits/export?${params.toString()}`, {
    method: 'GET'
  });
};

// Admin: Get visitor statistics with countries
export const getVisitorStats = async () => {
  return fetchWithAuth('/visits/visitors', {
    method: 'GET'
  });
};
